<mat-grid-list cols="3" rowHeight="170px" gutterSize="20px" tnbResponsiveGrid>
  @for (erzeugungsanlage of erzeugungsanlagen; track erzeugungsanlage.id) {
    <mat-grid-tile
      >
      <tnb-erzeugungsanlage-tile
        data-qa="erzeugungsanlage-tile"
        [erzeugungsanlage]="erzeugungsanlage">
      </tnb-erzeugungsanlage-tile>
    </mat-grid-tile>
  }
</mat-grid-list>


